export default "__VITE_ASSET__DN0iCcv4__"